module.exports = function (text) {
    var output = text.toString().toLowerCase()
        .replace(/\s+/g, '-')        // Replace spaces with -
        .replace(/^-+/, '')          // Trim - from start of text
        .replace(/-+$/, '');         // Trim - from end of text

    if (output[0] == "/")
        output = output.replace('/', '');
    if (output.indexOf('/')) {
        var last = output.split('/');
        last = last[last.length-1];
        if (last.length != 0) {
            output = last;
        }
    }
    output = output
        .replace(/\//g, '-')         // Replace / with -
        .replace(/[^\w\-]+/g, '')    // Remove all non-word chars
        .replace(/\-\-+/g, '-')      // Replace multiple - with single -

    if (output == '' || output == 'zaciname' || output == 'zaciname-') {
        output = 'homepage'
    }
    return output;
}


// WEBPACK FOOTER //
// ./core/xhr2/modules/classify.js